import { Customer } from "@/types/customer-type";

export function getInitials(name: string | null | undefined): string {
  if (!name || typeof name !== "string") return "?";
  const trimmed = name.trim();
  if (trimmed.length === 0) return "?";
  return trimmed
    .split(" ")
    .map((n) => n[0])
    .filter((char) => char) // Filter out empty strings
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function formatCurrency(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return "$0.00";
  return `$${amount.toFixed(2)}`;
}

export function getTotalOrders(customer: Customer): number {
  return customer.totalOrder || 0;
}

export function getAveragePerOrder(customer: Customer): number {
  const totalSpend = customer.totalSpend || 0;
  const totalOrders = getTotalOrders(customer);
  if (totalOrders === 0) return 0;
  return totalSpend / totalOrders;
}

export function hasOrderHistory(customer: Customer | null): boolean {
  if (!customer) return false;
  const totalSpend = customer.totalSpend || 0;
  const totalOrders = getTotalOrders(customer);
  return totalSpend > 0 || totalOrders > 0;
}
